import { useEffect, useState } from 'react';

function useNavParams() {
  const [hash, setHash] = useState('');
  const [state, setState] = useState<Record<string, string>>({});
  const baseHash = location.hash.split('&')[0];

  useEffect(() => {
    setHash(location.hash);
  }, [location.hash]);

  useEffect(() => {
    const params = location.hash.split('&').splice(1);
    let newState = {};

    params.forEach((param) => {
      const [key, value] = param.split('=');
      newState = { ...newState, [key]: value };
    });

    setState(newState);
  }, [hash]);

  const removeParam = (key: string) => {
    const newState = { ...state };
    delete newState[key];
    const newParams = Object.keys(newState)
      .map((key) => `${key}=${newState[key]}`)
      .join('&');

    location.href = `${baseHash}&${newParams}`;
  };

  const setParams = (params: Record<string, string>) => {
    const newState = { ...state, ...params };
    const newParams = Object.keys(newState)
      .map((key) => `${key}=${newState[key]}`)
      .join('&');

    location.href = `${baseHash}&${newParams}`;
  };

  return {
    removeParam,
    setParams,
    params: hash ? state : null
  };
}

export default useNavParams;
